<template>
  <v-main>
    <app-alert ref="alert"></app-alert>
    <app-idle-timeout
      v-if="page.name !== pages.TokenLogin.name && !hasError"
      ref="idle"
      :IdleTimeout="timeout"
      :WarningTimeout="dialogTimeout"
      :DisableConfirmation="disableTimeoutWarning"
      :DialogText="siteText.ui.idleTimeOutWarning"
      :ButtonText="siteText.ui.cancel"
      @OnWarningTimeout="handleIdleTimeout()"
    ></app-idle-timeout>
    <v-container class="page-container">
      <h2 v-show="page.displayPageTitle" class="h1 d-md-none d-sm-block">
        {{ page.description[language] }}
      </h2>
      <component :is="page.name" @show-alert="onShowAlert"> </component>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import appIdleTimeout from "./Idle.vue";
import appAlert from "./ui/Alert.vue";

import TokenLogin from "../pages/TokenLogin.vue";
import TestSelection from "../pages/TestSelection.vue";
import Test from "../pages/Test.vue";
import KioskLanding from "../pages/KioskLanding.vue";
import DateOfBithLogin from "../pages/DateOfBithLogin.vue";
import TestScoreCard from "../pages/TestScoreCard.vue";
import TestInstructions from "../pages/TestInstructions.vue";
import PracticeTest from "../pages/PracticeTest.vue";
import TestPage from "../pages/TestPage.vue";
import TestQuestionSummary from "../pages/TestQuestionSummary.vue";

export default {
  components: {
    appIdleTimeout,
    TokenLogin,
    DateOfBithLogin,
    TestSelection,
    TestInstructions,
    PracticeTest,
    Test,
    KioskLanding,
    TestScoreCard,
    TestPage,
    TestQuestionSummary,
    appAlert,
  },
  props: {
    page: null,
    language: String,
  },
  computed: {
    ...mapGetters([
      "idleTimeout",
      "resultsTimeout",
      "dialogTimeout",
      "siteText",
      "pages",
      "loginTimeout",
      "error",
    ]),
    disableTimeoutWarning() {
      return this.page && this.page.name === this.pages.DateOfBirthLogin.name
        ? true
        : false;
    },
    timeout() {
      let timeout = this.idleTimeout;
      if (this.page.name === this.pages.TestScoreCard.name) {
        timeout = this.resultsTimeout;
      } else if (this.page.name == this.pages.DateOfBirthLogin.name) {
        timeout = this.loginTimeout;
      } else {
        timeout = this.idleTimeout;
      }
      return timeout;
    },
    hasError() {
      return this.error && this.error.message && this.error.message !== "";
    },
  },
  methods: {
    ...mapActions(["finished"]),
    handleIdleTimeout() {
      this.finished();
    },
    async onShowAlert(args) {
      await this.$refs.alert.open(this.siteText.ui.alert, args.message);
      if (args.callback) {
        args.callback();
      }
    },
  },
  watch: {
    page(newPage, oldPage) {
      if (newPage !== oldPage && this.$refs.idle) {
        this.$refs.idle.reset(this.timeout);
      }
    },
  },
};
</script>

<style></style>

<style scoped>
.page-container {
  max-width: 1400px;
}
.v-main {
  overflow-y: auto !important;
}
</style>
